
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { calculatorCategories, getCalculatorsByCategory } from '@/lib/calculator-data';
import { Menubar, MenubarMenu, MenubarTrigger, MenubarContent, MenubarItem } from '@/components/ui/menubar';
import { Button } from '@/components/ui/button';
import { ShareButton } from './ShareButton';
import { UserAccountMenu } from './UserAccountMenu';

const calculatorsByCat = getCalculatorsByCategory();

const Header = () => {
  return (
    <header className="py-2 px-4 md:px-8 border-b bg-card/80 backdrop-blur-sm sticky top-0 z-40">
      <div className="container mx-auto flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 text-primary transition-opacity hover:opacity-80">
          <img src="/logo.png" alt="Earning Calculators.Com" className="w-10 h-10" />
          <span className="text-2xl font-bold font-headline tracking-tighter hidden sm:inline-block">Earning Calculators.Com</span>
        </Link>
        <div className="flex-grow flex justify-center">
            <Menubar className="border-none bg-transparent">
            {calculatorCategories.map(category => (
                <MenubarMenu key={category.id}>
                <MenubarTrigger asChild>
                    <Button variant="ghost" className="text-sm font-medium">
                    {category.name} <ChevronDown className="w-4 h-4 ml-1" />
                    </Button>
                </MenubarTrigger>
                <MenubarContent>
                    {calculatorsByCat[category.id]?.map(tool => (
                    <MenubarItem key={tool.slug} asChild>
                        <Link to={`/calculators/${tool.slug}`} className="flex items-center gap-2">
                        <tool.icon className="w-4 h-4 text-muted-foreground" />
                        <span>{tool.name}</span>
                        </Link>
                    </MenubarItem>
                    ))}
                </MenubarContent>
                </MenubarMenu>
            ))}
            </Menubar>
        </div>
        <div className="flex items-center gap-2">
          <ShareButton />
          <UserAccountMenu />
        </div>
      </div>
    </header>
  );
};

export default Header;
